<template>
  <div>
    <x-org-heading heading="Billing"></x-org-heading>
    <div class="mt-8">
      <h4>Billing Download</h4>
      <v-row no-gutters class="mt-4" align="end">
        <v-col sm="12" md="2">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                label="Billing month"
                readonly
                v-bind="attrs"
                v-on="on"
                :data-test-id="`${dataTestId}__billing-month-textfield`"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              min="2000-01"
              :max="`${new Date().getFullYear()}-${new Date().getMonth() + 1}`"
              type="month"
              no-title
              scrollable
              :data-test-id="`${dataTestId}__datepicker`"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false" :data-test-id="`${dataTestId}__datepicker-cancel-btn`">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(date)" :data-test-id="`${dataTestId}__datepicker-ok-btn`">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="ml-6">
          <x-button
            color="#58e2c2"
            buttonText="Download CSV"
            :clickFunction="downloadCSV"
            :data-test-id="`${dataTestId}__download-csv-btn`"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import BillingService from '../../../services/BillingService';
import DownloadService from '@/services/DownloadService';
export default {
  data() {
    return {
      date: `${new Date().getFullYear()}-${new Date().getMonth() + 1}`,
      menu: false,
      dataTestId: 'billing'
    };
  },
  props: ['title'],

  methods: {
    async downloadCSV() {
      try {
        const month = this.monthNames[this.date.split('-')[1] - 1]
          //eslint-disable-next-line
          .substr(0, 3)
          .toUpperCase();
        const year = this.date.split('-')[0];
        const response = await BillingService.generateBillingCSV({
          params: {
            month,
            year
          }
        });
        await DownloadService.downloadAFile({
          response,
          fileName: `billing_${month}_${year}`,
          fileType: '.csv'
        });
        this.snackbar('success', this.$message.DOWNLOAD_SUCCESS);
      } catch (err) {
        this.snackbar('error', this.$message.ERROR);
      }
    }
  }
};
</script>
<style scoped>
.v-input__control .v-input__slot {
  margin-bottom: 0px !important;
}
</style>
